__turbopack_context__.v({
  "animatedStrip": "DeskTutorChicky-module__4rgiPa__animatedStrip",
  "character": "DeskTutorChicky-module__4rgiPa__character",
  "desk-tutor-reply-in": "DeskTutorChicky-module__4rgiPa__desk-tutor-reply-in",
  "desk-tutor-teaching-loop": "DeskTutorChicky-module__4rgiPa__desk-tutor-teaching-loop",
  "deskOcclusion": "DeskTutorChicky-module__4rgiPa__deskOcclusion",
  "frame": "DeskTutorChicky-module__4rgiPa__frame",
  "reply": "DeskTutorChicky-module__4rgiPa__reply",
  "scene": "DeskTutorChicky-module__4rgiPa__scene",
  "staticStrip": "DeskTutorChicky-module__4rgiPa__staticStrip",
});
